export default __webpack_public_path__ + "static/media/students.20dd7d1e.jpeg";